import manageRecords from '../assets/Manage_records_digitally.jpg';
import attractPatient from '../assets/attract_more_patient.jpg';
import manageReputation from '../assets/manage_your_reputation.jpg';
import automatePractice from '../assets/automate_your_practice.jpg';
import deliverBetterCare from '../assets/Deliver_better_care.jpg';
import getPaidFaster from '../assets/get_paid_faster.jpg';
import gainInsights from '../assets/get_deeper_insights.jpg';
import EnhanceExperience from '../assets/Enhance_your_patient_experience.jpg'


const aboutSolutionsData = [
    {
        id: 1,
        title: "Manage records digitally",
        subtitle: "Digitally manage patient records",
        text: "Get everything your practice needs, from appointments, streamlined patient documentation, electronic medical records, to a comprehensive view of the patient and their history, eRx, eLabs, and more.",
        image: manageRecords,
        buttonLabel: "Learn more",
    },
    {
        id: 2,
        title: "Attract more patients",
        subtitle: "Set the foundation for practice growth even before the initial visit",
        text: "Cultivate a distinctive reputation that stands out to savvy patients in their search for care. Utilize patient surveys to enhance your practice's brand awareness and credibility, drawing in more patients in the process.",
        image: attractPatient,
        buttonLabel: "Learn more",
    },
    {
        id: 3,
        title: "Manage your reputation",
        subtitle: "Create an outstanding initial impression",
        text: "Cultivate a distinctive reputation that stands out to savvy patients in their search for care. Utilize patient surveys to enhance your practice's brand awareness and credibility, drawing in more patients in the process.",
        image: manageReputation,
        buttonLabel: "Learn more",
    },
    {
        id: 4,
        title: "Automate your practice",
        subtitle: "Boost efficiencies and minimize workload",
        text: "Automating your practice goes beyond simplifying communication, billing, and front-office workflows; it's a win-win. Providers and staff experience reduced workload, while patients enjoy greater convenience and ease.",
        image: automatePractice,
        buttonLabel: "Learn more",
    },
    {
        id: 5,
        title: "Deliver better care",
        subtitle: "Focus your time on what truly matters",
        text: "Enable each provider in your practice to concentrate on their core strengths and well-being by offering clinical tools that support rather than hinder patient care delivery. Ensure patients receive the attention they deserve and enable comprehensive care through a holistic understanding of their health.",
        image: deliverBetterCare,
        buttonLabel: "Learn more",
    },
    {
        id: 6,
        title: "Get paid faster",
        subtitle: "Enhance your practice's financial well-being",
        text: "Running a modern, profitable practice involves more than exceptional patient care. Set your practice up for success by seamlessly navigating insurance reimbursements and facilitating frictionless patient payments. We'll assist you in simplifying the payment process to ensure you get paid efficiently.",
        image: getPaidFaster,
        buttonLabel: "Learn more",
    },
    {
        id: 7,
        title: "Gain deeper insights",
        subtitle: "Transform data into actionable insights for empowerment",
        text: "In the ever-evolving healthcare landscape, no practice should be left behind. Proactively discover clinical, revenue, reputation management, and website insights to diagnose and address your essential practice needs.",
        image: gainInsights,
        buttonLabel: "Learn more",
    },
    {
        id: 8,
        title: "Enhance your patient experience",
        subtitle: "Ensure ongoing involvement and interaction",
        text: "Meet heightened patient expectations by consistently offering convenient digital touchpoints. Implement online scheduling, appointment reminders, custom intake forms, and text messaging to create a positive experience, fostering patient loyalty and encouraging return visits to your practice.",
        image: EnhanceExperience,
        buttonLabel: "Learn more",
    },
    // Add more items as needed

];

export default aboutSolutionsData;
